import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./installationLinks.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { WireI18n } from '~/modules/stores/i18nStore';
import { routerStore, selectShowInputErrors } from '~/modules/stores/routerStore';
import { securityReviewStore, selectClientAppItems, selectMobileInstallationLinks, selectTestEnviroments } from '~/modules/stores/securityReviewStore';
import { confirmPrompt } from '~/modules/utilities/browserUtilities';
import { basicTableKeyboardNavigation } from '~/modules/utilities/keyboardUtilities';
export let APPLICATION_TYPES = /*#__PURE__*/function (APPLICATION_TYPES) {
  APPLICATION_TYPES["clientApplications"] = "clientApplications";
  APPLICATION_TYPES["mobileApplications"] = "mobileApplications";
  return APPLICATION_TYPES;
}({});
const DELETE_COLUMN = 2;
class InstallationLinks extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = void 0;
    this.required = false;
    this.uniqueIdentifier = void 0;
    this.maxLength = '2000';
    this.requiredItemsLabel = void 0;
    this.installationLinks = [];
    this.testEnviroments = void 0;
    this.labelsShared = {};
    this.labels = {};
    this.keyboardNavigation = false;
    this.requiredText = void 0;
    this.handleRemoveLink = async event => {
      if (await confirmPrompt(this.labelsShared.confirmDelete)) {
        const installationLinkToDelete = parseInt(event.currentTarget.dataset.index);
        securityReviewStore.removeApplicationsLinks(this.uniqueIdentifier, installationLinkToDelete);
      }
    };
    this.handleChangeDescription = (value, event) => {
      const installationLinkIndex = parseInt(event.currentTarget.dataset.id);
      let installationLinkItem;
      if (this.uniqueIdentifier === APPLICATION_TYPES.clientApplications) {
        installationLinkItem = selectClientAppItems(securityReviewStore.getState())[installationLinkIndex];
      } else {
        installationLinkItem = selectMobileInstallationLinks(securityReviewStore.getState())[installationLinkIndex];
      }
      installationLinkItem.description = value;
      securityReviewStore.editApplicationsLinks(this.uniqueIdentifier, installationLinkItem, installationLinkIndex);
    };
    this.handleChangeLink = (value, event) => {
      const installationLinkIndex = parseInt(event.currentTarget.dataset.id);
      let installationLinkItem;
      if (this.uniqueIdentifier === APPLICATION_TYPES.clientApplications) {
        installationLinkItem = selectClientAppItems(securityReviewStore.getState())[installationLinkIndex];
      } else {
        installationLinkItem = selectMobileInstallationLinks(securityReviewStore.getState())[installationLinkIndex];
      }
      installationLinkItem.installationLink = value;
      this.installationLinks[installationLinkIndex].link = value;
      securityReviewStore.editApplicationsLinks(this.uniqueIdentifier, installationLinkItem, installationLinkIndex);
    };
  }
  securityReviewStoreConnected(testEnviroments) {
    var _this$testEnviroments;
    this.testEnviroments = testEnviroments;
    if (this.uniqueIdentifier === APPLICATION_TYPES.clientApplications && this.testEnviroments.clientApps) {
      this.installationLinks = this.testEnviroments.clientApps.map((item, index) => ({
        link: item.installationLink,
        configData: item.description,
        index: index,
        iteratorKey: item.iteratorKey
      }));
    } else if ((_this$testEnviroments = this.testEnviroments.mobileApps) !== null && _this$testEnviroments !== void 0 && _this$testEnviroments.installationLinks) {
      this.installationLinks = this.testEnviroments.mobileApps.installationLinks.map((item, index) => ({
        link: item.installationLink,
        configData: item.description,
        index: index,
        iteratorKey: item.iteratorKey
      }));
    }
  }
  i18nCallback(i18n) {
    this.labels = i18n.installationLinks;
    this.labelsShared = i18n.shared;
    this.requiredText = i18n.shared.requiredField;
  }
  get showEmptyState() {
    return this.installationLinks.length === 0;
  }
  get showInputErrors() {
    return selectShowInputErrors(routerStore.getState()) && this.required;
  }
  handleAddLink() {
    securityReviewStore.addApplicationsLinks(this.uniqueIdentifier);
  }
  handleKeyboard(event) {
    this.keyboardNavigation = basicTableKeyboardNavigation(this.keyboardNavigation, this.installationLinks.length - 1, DELETE_COLUMN, this.handleRemoveLink, event, this.template);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(InstallationLinks, {
  publicProps: {
    label: {
      config: 0
    },
    required: {
      config: 0
    },
    uniqueIdentifier: {
      config: 0
    },
    maxLength: {
      config: 0
    },
    requiredItemsLabel: {
      config: 0
    }
  },
  track: {
    installationLinks: 1
  },
  wire: {
    securityReviewStoreConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: securityReviewStore,
          selector: selectTestEnviroments
        };
      }
    },
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["testEnviroments", "labelsShared", "labels", "keyboardNavigation", "requiredText", "handleRemoveLink", "handleChangeDescription", "handleChangeLink"]
});
const __lwc_component_class_internal = _registerComponent(InstallationLinks, {
  tmpl: _tmpl,
  sel: "appx-installation-links",
  apiVersion: 62
});
export default __lwc_component_class_internal;